const TOKEN_KEY = 'adminToken';

export class AuthError extends Error {}

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

async function request(method, path, body) {
	const headers = { Accept: 'application/json' };
	const token = getToken();

	if (token) headers.Authorization = `Bearer ${token}`;
	if (body !== undefined) headers['Content-Type'] = 'application/json';

	const response = await fetch(path, {
		method,
		headers,
		body: body === undefined ? undefined : JSON.stringify(body),
	});

	let data = null;

	try {
		data = await response.json();
	} catch (err) {}

	if (response.status === 401 && path !== '/api/login') {
		clearToken();
		throw new AuthError('Your session expired. Log in again.');
	}

	if (!response.ok) {
		throw new Error(data?.error || `Request failed (${response.status})`);
	}

	return data;
}

const albumPath = (albumId) =>
	`/api/admin/albums/${encodeURIComponent(albumId)}`;

export const login = async (code) => {
	const { token } = await request('POST', '/api/login', { code });
	setToken(token);
};

export const checkSession = () => request('GET', '/api/admin/session');
export const getAdminGallery = () => request('GET', '/api/admin/gallery');
export const createAlbum = (fields) =>
	request('POST', '/api/admin/albums', fields);
export const updateAlbum = (albumId, fields) =>
	request('PATCH', albumPath(albumId), fields);
export const deleteAlbum = (albumId) => request('DELETE', albumPath(albumId));
export const deletePhoto = (albumId, key) =>
	request(
		'DELETE',
		`${albumPath(albumId)}/photos/${encodeURIComponent(key)}`
	);

const putFile = (url, file, onProgress) =>
	new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();

		xhr.open('PUT', url);
		xhr.setRequestHeader('Content-Type', file.type);
		xhr.upload.onprogress = (e) => {
			if (e.lengthComputable) onProgress(e.loaded / e.total);
		};
		xhr.onload = () =>
			xhr.status >= 200 && xhr.status < 300
				? resolve()
				: reject(new Error(`Upload failed (${xhr.status})`));
		xhr.onerror = () => reject(new Error('Upload failed (network error)'));
		xhr.send(file);
	});

// Upload the original straight to storage, then make the site versions.
export const uploadPhoto = async (albumId, file, onStatus) => {
	onStatus({ state: 'uploading', progress: 0 });

	const { key, uploadUrl } = await request(
		'POST',
		`${albumPath(albumId)}/uploads`,
		{ filename: file.name, size: file.size, contentType: file.type }
	);

	await putFile(uploadUrl, file, (progress) =>
		onStatus({ state: 'uploading', progress })
	);

	onStatus({ state: 'processing' });

	return request(
		'POST',
		`/api/admin/process/${encodeURIComponent(
			albumId
		)}/${encodeURIComponent(key)}`,
		{ filename: file.name }
	);
};
